import { render, staticRenderFns } from "./complete-registration.vue?vue&type=template&id=2fac2ffd&"
import script from "./complete-registration.vue?vue&type=script&lang=js&"
export * from "./complete-registration.vue?vue&type=script&lang=js&"
import style0 from "@/assets/auth-screen.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "complete-registration.vue"
export default component.exports